import { useDispatch, useSelector } from "react-redux";

import { cleanToken, getToken } from "@/redux/actions/token";
import { timelog } from "@/utils/TimeLog";

export const useToken = () => {
  const userData = useSelector((state) => state.vida.userData);
  const planSelected = useSelector((state) => state.plans.planSelected);

  const dispatch = useDispatch();

  const updateSessionToken = (errorHandler) => {
    const MAX_RETRIES_TOKEN = 3;
    const total = window.intentosSesion + 1;

    if (total >= MAX_RETRIES_TOKEN) {
      timelog(
        `[CHECKOUT] total sesiones expiradas = ${MAX_RETRIES_TOKEN} => ERROR`
      );
      errorHandler();
      return;
    }

    timelog(`[CHECKOUT] total sesiones expiradas = ${total} => GET NEW TOKEN`);
    dispatch(cleanToken());
    const payloadToken = {
      producto: "VCT",
      ideCotizacion: planSelected?.idCotizacion,
      correo: userData.email,
      idePlan: String(planSelected?.planId),
    };
    dispatch(getToken(payloadToken));

    window.intentosSesion = total;
  };


  const updateRetriesPayment = (handlerSuccess, handlerError) => {
    const MAX_RETRIES_PAY = 3;
    const total = window.intentos + 1;

    if (total >= MAX_RETRIES_PAY) {
      timelog("[CHECKOUT] intentos erroneos = 3 => ERROR");
      handlerError();
      return;
    }

    timelog(`[CHECKOUT] intentos erroneos = ${total} => NEW RETRY`);
    window.intentos = total;
    handlerSuccess();
  };

  return {
    updateSessionToken,
    updateRetriesPayment,
  };
}